import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Viimasest sisselogimisest on jäänud tooted ostukorvi!

  <span style="color:#85c1dc;">**FI:**</span>
  Sinulla on jo tuotteita ostoslistassa

  <span style="color:#85c1dc;">**RU:**</span>
  У Вас уже есть товары в корзине
*/
/* @__NO_SIDE_EFFECTS__ */
const m759 = msg(
  mf`Viimasest sisselogimisest on jäänud tooted ostukorvi!`,
  mf`Sinulla on jo tuotteita ostoslistassa`,
  mf`У Вас уже есть товары в корзине`,
)

export { m759 as 'w.basket.merge.title' }